<div class="dialog-wrapper tw-relative">
    <div class="tw-flex tw-w-full tw-justify-between">
        <h1
            class="tw-text-3xl"
            matDialogTitle>
            {{ 'SHARE-PERMISSIONS.TITLE' | translate }}
        </h1>
        <button
            mat-icon-button
            mat-dialog-close>
            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
        </button>
    </div>

    @if (!showSuccessScreen) {
        <div>
            <div class="tw-grid tw-grid-cols-12 tw-grid-rows-1 tw-gap-x-12">
                <div class="tw-col-span-3">
                    <mat-form-field
                        appearance="fill"
                        class="tw-max-w-80">
                        <mat-label class="tw-text-sm">{{
                            'SPEDITEUR.SHARE-PERMISSIONS.ORG-PLACEHOLDER'
                                | translate
                        }}</mat-label>
                        <mat-select
                            [formControl]="orgCtrl"
                            [placeholder]="
                                'SPEDITEUR.SHARE-PERMISSIONS.ORG-PLACEHOLDER'
                                    | translate
                            "
                            class="tw-w-full"
                            #singleSelect
                            required>
                            <mat-option>
                                <ngx-mat-select-search
                                    [formControl]="
                                        orgFilterCtrl
                                    "></ngx-mat-select-search>
                            </mat-option>
                            <cdk-virtual-scroll-viewport
                                itemSize="42"
                                style="height: 168px; width: 100%">
                                <mat-option
                                    style="height: 42px"
                                    *cdkVirtualFor="
                                        let org of filteredOrgs | async
                                    "
                                    [value]="org">
                                    {{ org.fullSiteName }}
                                </mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="tw-col-span-7">
                    <!-- View toggle and controls will be handled by configurable view -->
                </div>
                <div class="tw-col-span-2">
                    <div class="tw-flex tw-flex-col tw-items-center">
                        <button
                            (click)="sharePermission()"
                            [disabled]="
                                !amountOfSelectedItems || !orgCtrl.value
                            "
                            mat-raised-button
                            class="tw-h-14"
                            color="primary">
                            {{ 'SHARE-PERMISSIONS.ACTION' | translate }}
                        </button>
                        @if (!orgCtrl.value) {
                            <span class="tw-mt-1 tw-text-red-600">
                                {{
                                    'SPEDITEUR.SHARE-PERMISSIONS.NO-SITE-ERROR'
                                        | translate
                                }}
                            </span>
                        }
                    </div>
                </div>
            </div>
            <div class="tw-mt-5">
                <!-- View toggle buttons -->
                <div class="tw-mb-4">
                    <mat-button-toggle-group
                        aria-label="type of view"
                        [value]="currentViewType()"
                        (change)="onViewChanged($event.value)">
                        <mat-button-toggle value="folders">{{
                            'OUTGOING-GOODS.TOGGLER.FOLDERS' | translate
                        }}</mat-button-toggle>
                        <mat-button-toggle value="deliverynotes">{{
                            'OUTGOING-GOODS.TOGGLER.DELIVERY-NOTES' | translate
                        }}</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <!-- Generic table component (copied from configurable view) -->
                <app-generic-table
                    [data]="data()"
                    [columns]="tableColumns()"
                    [loading]="loading()"
                    [error]="error()"
                    [sortable]="
                        currentConfig()?.tableConfig?.features?.sortable ||
                        false
                    "
                    [filterable]="
                        currentConfig()?.tableConfig?.features?.filterable ||
                        false
                    "
                    [paginated]="
                        currentConfig()?.tableConfig?.features?.paginated ||
                        false
                    "
                    [selectable]="
                        currentConfig()?.tableConfig?.features?.selectable ||
                        false
                    "
                    [expandable]="
                        currentConfig()?.tableConfig?.features?.expandable ||
                        false
                    "
                    [showActions]="false"
                    [showFilter]="true"
                    [maxHeight]="'500px'"
                    (selectionChange)="onSelectionChange($event)"
                    (sortChange)="onRefresh()"
                    (refresh)="onRefresh()">
                </app-generic-table>
            </div>
        </div>
    }

    @if (showSuccessScreen) {
        <div class="tw-text-center">
            <div class="tw-text-3xl tw-font-bold">
                {{ 'SHARE-PERMISSIONS.SUCCESS-TITLE' | translate }}
            </div>
            <div class="tw-text-lg">
                <hr />
                @for (note of sharedDeliveryNotes; track note) {
                    <div>
                        <div class="tw-text-2xl tw-font-bold">
                            {{ note.number }}
                        </div>
                    </div>
                }
                <div class="tw-mt-4">
                    <button
                        mat-button
                        mat-dialog-close>
                        {{ 'SHARE-PERMISSIONS.SUCCESS-CLOSE' | translate }}
                    </button>
                </div>
            </div>
        </div>
    }
</div>
